import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import LocaleProvider from 'antd/es/locale-provider';
import locale from 'antd/lib/locale/es_ES';
import moment from 'moment';
import routes from '../routes';
import RouteWrapper from '../routes/RouteWrapper';
import EnrollmentProvider from '../providers/EnrollmentContextProvider';
import ParamsProvider from '../domain/params/ParamsContext';
import EnrollmentFormContextProvider from '../providers/EnrollmentFormContextProvider';
import '../styles/app.less';
import EnrollmentInstantiationProvider from '../providers/EnrollmentInstantiationProvider/EnrollmentInstantiationProvider';

moment.updateLocale('es', {
  weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  week: {
    dow: 1,
  },
  monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
});

function App() {
  return (
    <LocaleProvider locale={locale}>
      <Router>
        <ParamsProvider>
          <EnrollmentProvider>
            <EnrollmentFormContextProvider>
              <EnrollmentInstantiationProvider>
                <Switch>
                  {routes.map((route, index) => {
                    const key = `route_${index}`;
                    return <RouteWrapper key={key} {...route} />;
                  })}
                  <Route exact path="/">
                    <Redirect to="/enrolamiento" />
                  </Route>
                </Switch>
              </EnrollmentInstantiationProvider>
            </EnrollmentFormContextProvider>
          </EnrollmentProvider>
        </ParamsProvider>
      </Router>
    </LocaleProvider>
  );
}

export default App;
